import { getPOSProductCatalog } from '../services/posService';
import { getCatalogMeta, saveProductCatalog } from './posOfflineStore';

export async function refreshOfflineCatalog(locationId: number): Promise<number> {
  const products = await getPOSProductCatalog(locationId);
  await saveProductCatalog(locationId, products);
  return products.length;
}

export async function tryRefreshOfflineCatalog(locationId: number): Promise<void> {
  if (!navigator.onLine) return;
  try {
    await refreshOfflineCatalog(locationId);
  } catch (err) {
    console.warn('[offline] catalog refresh failed', err);
  }
}

export { getCatalogMeta };
